import { create } from 'zustand';
import FeatureFlagsService, {
  FeatureFlag,
  MAINTENANCE_BANNER_KEY,
} from '../service/FeatureFlagsService';

type FeatureFlagsState = {
  flags: FeatureFlag[];
  isMaintenanceBannerEnabled: boolean;
  fetchFlags: () => Promise<void>;
  setFlags: (flags: FeatureFlag[]) => void;
};

export const useFeatureFlagsStore = create<FeatureFlagsState>(set => ({
  flags: [],
  isMaintenanceBannerEnabled: false,
  setFlags: (flags: FeatureFlag[]) => {
    const maintenanceFlag = flags.find(
      flag => flag.key === MAINTENANCE_BANNER_KEY,
    );
    set({
      flags,
      isMaintenanceBannerEnabled: maintenanceFlag?.enabled ?? false,
    });
  },
  fetchFlags: async () => {
    try {
      const flags = await FeatureFlagsService.getAll();
      const maintenanceFlag = flags.find(
        flag => flag.key === MAINTENANCE_BANNER_KEY,
      );
      set({
        flags,
        isMaintenanceBannerEnabled: maintenanceFlag?.enabled ?? false,
      });
    } catch (error) {
      console.error('Failed to fetch feature flags', {
        error: error instanceof Error ? error.message : 'Unknown error',
      });
    }
  },
}));
